import { FC, useMemo } from 'react';
import { CancelToken } from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { FetchState } from '../../../../store/fetchState';
import { getOptionsActivity, selectOptionsActivity, selectOptionsActivityState } from '../../../../store/entities/optionsActivity';
import { QcsAutocomplete } from '../../../common/form/QcsAutocomplete';
import { getLangNameObj } from '../../../../utils/format';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
}

export const VisitationActivityAutocomplete: FC<Props> = ({ multiple, name, label }) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const activities = useAppSelector(selectOptionsActivity);
  const optionsState = useAppSelector(selectOptionsActivityState);

  const mappedOptions = useMemo<ReferenceDto[]>(
    () =>
      activities.map((dto) => ({
        id: dto.id!,
        name: getLangNameObj(i18n, dto),
      })),
    [activities, i18n],
  );

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsActivity(cancelToken, undefined, search));
  };

  return (
    <QcsAutocomplete<ReferenceDto>
      multiple={multiple}
      name={name}
      label={label}
      options={mappedOptions}
      loading={optionsState === FetchState.Loading}
      loadingError={optionsState === FetchState.Error}
      loadOptions={loadOptions}
      getOptionId={(option) => option.id}
      getOptionName={(option) => option.name ?? option.id}
      getValueIfNotFound={(option) => option}
    />
  );
};
